export default __webpack_public_path__ + "static/blob10-623cd51024fa4aa3c4839e3c95a1d869.svg";